import {StockInformationModel} from "../domain/stockInformationModel";

type OutOfStockModelType = Pick<
    StockInformationModel,
    "leadOut" | "isAutoOffline" | "customArtwork" | "minimumQuantity"
>;

export class OutOfStockModel {
    private _model: OutOfStockModelType;

    constructor(model: OutOfStockModelType) {
        this._model = model;
    }

    get minimumQuantity() {
        return this._model.minimumQuantity;
    }

    get showNotifyMeWhenInStock() {
        return (this._model.leadOut > 100 || this._model.isAutoOffline || (this._model.customArtwork && this._model.minimumQuantity > 1))
    }

    static create(model: StockInformationModel) {
        return new OutOfStockModel(model);
    }
}
